import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import Swal from 'sweetalert2';
import { useAuth } from '../_helper/Auth/AuthProvider';

export const useLogout = () => {
  const navigate = useNavigate();
  const [, setLoading] = useState(false);
  const { logout } = useAuth();

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log me out!',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      preConfirm: async () => {
        setLoading(true);
        try {
          const logoutResult = await logout();
          if (!logoutResult || !logoutResult.success) {
            const error = logoutResult && logoutResult.error;
            Swal.showValidationMessage('Error during logout: ' + (error || 'Unknown error'));
            console.error('Error during logout:', error);
            return false;
          }
          return logoutResult;
        } catch (error) {
          Swal.showValidationMessage('Error during logout: ' + (error?.message || 'Unknown error'));
          console.error('Error during logout:', error);
          return false;
        } finally {
          setLoading(false);
        }
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        toast.success(result.value.message || 'Logout successful!');
        navigate('/auth/login');
      }
    });
  };

  return { handleLogout };
};
